var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11,
    cy: 11,
    rx: 11,
    ry: 11,
    transform: "rotate(-180 11 11)",
    fill: "#D43939"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3726 9.16666L12.6123 9.92695L13.4642 10.7843H9.05884V11.8627H13.4642L12.6123 12.7147L13.3726 13.4804L15.5294 11.3235L13.3726 9.16666ZM6.90198 7.54901H10.6765V6.47058H6.90198C6.30884 6.47058 5.82355 6.95588 5.82355 7.54901V15.098C5.82355 15.6912 6.30884 16.1765 6.90198 16.1765H10.6765V15.098H6.90198V7.54901Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.605cb0c6b1f3aaa52b0a29ea8d5ef7b7.svg";
export { ForwardRef as ReactComponent };